import {isMobile, showErrorToast} from "../helpers";

let recognition = null;
let isRecording = false;
let stopListeners

//gestione icone text to speech
export const voiceIcons = {
  desktop: {
    default: '/themes/custom/adoption_management/assets/icons/volume.svg',
    active: '/themes/custom/adoption_management/assets/icons/volume-active.svg',
    defaultText: 'Leggi la risposta',
    activeText: 'Lettura in corso...',
    width: '158px',
    height: '48px'
  },
  mobile: {
    default: '/themes/custom/adoption_management/assets/icons/volume.svg',
    active: '/themes/custom/adoption_management/assets/icons/volume-active.svg',
    defaultText: 'Leggi',
    activeText: 'Lettura...',
    width: '90px',
    height: '72px'
  }
};

export function initializeRecording() {
    if(recognition) return;

    if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window))
    {
        console.warn('SpeechRecognition non supportato:', navigator.userAgent);
        showErrorToast('Funzionalità speech-to-text non disponibile sul browser corrente');
        return;
    }



    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    recognition = new SpeechRecognition();

    recognition.lang = 'it-IT';
    recognition.interimResults = !isMobile();
    recognition.continuous = !isMobile();

    if (isMobile()) {
      recognition.maxAlternatives = 1;
    }

    recognition.onstart = () => {
        isRecording = true;
        toggleRecordButton(false);
        toggleInputButton(true);
    };

    recognition.onresult = (event) => {
        let finalTranscript = '';

        if (isMobile()) {
          // Mobile: stampa solo il blocco finale a fine registrazione
          const last = event.results.length - 1;
          const transcript = event.results[last][0].transcript;
          if (event.results[last].isFinal) {
            finalTranscript += transcript + ' ';
            updateInputValue(finalTranscript);
          }
        } else {
          // Desktop: trascrizione continua mentre registra
          for (let i = 0; i < event.results.length; ++i) {
              finalTranscript += event.results[i][0].transcript;
          }

          if(finalTranscript.length > 0) {
            updateInputValue(finalTranscript)
          }
        }


    };

    recognition.onerror = (event) => {
        console.error("Errore Speech:", event.error);
        stopRecordingUI();
    };


    recognition.onend = () => {
        stopRecordingUI();
    };


    jQuery('body').on('click', '#voice-record', function() {
        if (isRecording) {
            recognition.stop();
            stopRecordingUI();
        } else {
            try {
                recognition.start();
                toggleUndoButton(true);
            } catch (error) {
                console.error('recognition già avviata o in errore: ' , error)
            }
        }
    });

     jQuery('body').on('click', '#undo-record', function() {
        if (isRecording) {
            recognition.abort();
            stopRecordingUI();
            jQuery('#chatbot-input').val('')
        }
    });

}

function updateInputValue(transcript) {
  const $input = jQuery('#chatbot-input');
  $input.val(transcript);

  //scrolling durante la registrazione
  const inputElement = $input[0];
  inputElement.scrollLeft = inputElement.scrollWidth;
}



export function stopRecordingUI() {
        isRecording = false;
        jQuery('#mic-icon').attr( 'src' , '/themes/custom/adoption_management/assets/icons/microphone.svg');
        toggleUndoButton(false);
    }

export async function speakResponse(text, onStart, onEnd) {
    // Stop se sta già parlando
    if (window.speechSynthesis.speaking) {
        window.speechSynthesis.cancel();
        if (onEnd) onEnd();
        return;
    }

    if (!stopListeners) registerForcedStopListeners();

    // Pulizia del testo per lettura più fluida
    const cleanedText = text
        .replace(/<\/p>/g, ". ")
        .replace(/<br\s?\/?>/g, ". ")
        .replace(/<\/li>/g, ". ")
        .replace(/<\/?[^>]+(>|$)/g, "")
        .replace(/\s+/g, ' ').trim()
        .replace(/\*\*/g, '')
        .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
        .replace(/#{1,6}\s?/g, '');

    const utterance = new SpeechSynthesisUtterance(cleanedText);

    utterance.lang = 'it-IT';

    const preferredVoice = await getItalianMaleVoice()

    if (preferredVoice) {
        utterance.rate = 0.95;   // leggermente più lento
        utterance.pitch = 0.9;   // leggermente più grave
        utterance.volume = 1;
        utterance.voice = preferredVoice;
    }


   // Evento: Inizio lettura
    utterance.onstart = () => { if (onStart) onStart(); };

    // Evento: Fine lettura (o interruzione)
    utterance.onend = () => { if (onEnd) onEnd(); };
    utterance.onerror = () => { if (onEnd) onEnd(); };

    window.speechSynthesis.speak(utterance);
}

async function getItalianMaleVoice() {
  await sleep(100)
  const voices = speechSynthesis.getVoices();
  const ITALIAN_MALE_VOICES_PRIORITY = [
      // Microsoft Edge
      "Microsoft Diego Online (Natural) - Italian (Italy)",
      // Apple / Safari
      "Luca",
      "Google italiano",
    ];

  // 1️⃣ match per nome noto
  for (const name of ITALIAN_MALE_VOICES_PRIORITY) {
    const voice = voices.find(v => v.name === name);
    if (voice) return voice;
  }

  return null;
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export function toggleRecordButton(start) {
    jQuery('#voice-record').toggleClass('p-2' , start);
    jQuery('#mic-icon').toggleClass('size-6' , start);
    if (!start) {
        jQuery('#mic-icon').attr( 'src' , '/themes/custom/adoption_management/assets/icons/stop-button.svg');
        updateInputPadding(true);
    } else {
        jQuery('#mic-icon').attr( 'src' , '/themes/custom/adoption_management/assets/icons/microphone.svg');
        jQuery('#undo-record').toggleClass('hidden' , start);
        jQuery('#chatbot-submit').toggleClass('hidden' , !start);
        updateInputPadding(false);
    }
}

export function toggleUndoButton(show) {
    const $input = jQuery('#chatbot-input');
    if (show) {
        jQuery('#undo-record').removeClass('hidden');
        jQuery('#chatbot-submit').addClass('hidden');
        updateInputPadding(true);
    } else {
        jQuery('#undo-record').addClass('hidden');
        jQuery('#chatbot-submit').removeClass('hidden');
        updateInputPadding(false);
        if (!$input.val()) {
            jQuery('.home-chatbot-block__input').removeClass('ready');
        }
    }
}

export function toggleInputButton(enabled) {
    jQuery('.home-chatbot-block__input').toggleClass('ready' , enabled);
    jQuery('#chatbot-submit').toggleClass('pointer-events-none' , !enabled).prop('disabled', !enabled);
}

//gestione del padding nell'input per evitare errori di sovrapposizione
function updateInputPadding(isExpanded) {
    const $input = jQuery('#chatbot-input');
    if (isExpanded) {
        $input.removeClass('pr-28').addClass('pr-40');
    } else {
        $input.removeClass('pr-40').addClass('pr-28');
    }
}

export function stopAllAudio() {
    if (window.speechSynthesis.speaking) {
        window.speechSynthesis.cancel();
    }
    if (isRecording && recognition) {
        recognition.abort();
        stopRecordingUI();
    }
}

function registerForcedStopListeners() {
  //gestione stop riproduzione al cambio scheda
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopAllAudio();
    }
  });
  //gestione stop riproduzione al click sulla sidebar
  jQuery('body').on('click', 'a, .sidebar-link, .menu-item, [data-drupal-link-system-path]', function() {
    stopAllAudio();
  });

  stopListeners = true
}

